import React, { Component } from "react";
import CenterBlock from "./CenterBlock";
import { Link, Redirect } from "react-router-dom";
import APICall from "../Utils/APICall";
import Spinner from "../Utils/Spinner";
import MyTable from "../Utils/MyTable";
import Modal from "react-modal";
import { throttle } from "lodash";
import DropdownLinkMenu from "./DropdownLinkMenu";
import { DataContext } from "../Contexts/DataContexts";



export default class VetsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      data: [],
      errorMessage: null,
      searchQuery: "",
      page: 1,
      pageSize: 10,
      modalIsOpen: false,
      uploadErrorMessage: null,
      uploading: false,
      redirect: null,
      user: {},
      alreadyGotResults: false,
    };

    this.RenderTable = this.RenderTable.bind(this);
    this.init = this.init.bind(this);

    this.throttledReload = throttle(() => {
      this.init(this.state.page, this.state.pageSize, this.state.searchQuery);
    }, 500);
  }

  componentDidMount() {
    Modal.setAppElement("body");
    this.init();
    //        new Functions().whoIsLoggedIn(this.setLoggedInUser, false);
  }

  RenderTable(_data) {
    const { selectRecord } = this.props;

    const headerList = [
      {
        Header: "",
        accessor: "actionsComponent",
      },
      {
        Header: "Name",
        accessor: "nameComponent",
      },
      {
        Header: "Phone number",
        accessor: "phoneNumber",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "State",
        accessor: "state",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "VCN Number",
        accessor: "vcnRegistrationNumber",
      },
    ];

    _data._data.forEach((element) => {
      element.nameComponent = (
        <strong className="clickable" onClick={() => selectRecord(element)}>
          {element.name}
        </strong>
      );
      element.actionsComponent = (
        <DropdownLinkMenu
          label="..."
          linksArray={[
            `/in/all-certificates/${element.id}`,
            `/in/all-inspection-reports/0/0/${element.id}`,
          ]}
          linkLabelsArray={[
            "View Issued Certificates",
            "View Inspection Reports",
          ]}
        />
      );
    });

    const tableHeader = React.useMemo(() => headerList, []);

    const tableData = React.useMemo(() => _data, []);
    return (
      <div style={{ zoom: "0.85" }}>
        <MyTable
          columns={tableHeader}
          data={tableData._data}
          enableSearch={true}
          cssArray={["w50px", "", "", ""]}
        />
      </div>
    );
  }


  static contextType = DataContext;

  init(page, pageSize, query) {
    if (!query) query = "";

    this.setState({
      errorMessage: null,
      loading: true,
      searchQuery: query,
      page: page,
      pageSize: pageSize,
    });

    const { globalState, addItem } = this.context;
    this.setState({ profile: globalState?.data })
    const { state, country, userRole } = globalState?.user

    let apiURL = `api/vets/get/${country}/${state}`

    if (userRole == "superadmin") {
      apiURL = "api/vets/list"
    }


    // APICall(`api/vets/get/${country}/${state}`, "GET", {})
    // APICall(`api/vets/list`, "GET", {})
    APICall(`${apiURL}`, "GET", {})
      .then((data) => {
        var response = data.data;
        if (response.isSuccess) {
          this.setState({ loading: false, data: null }, () => {
            this.setState({ data: response.data });
          });
        } else {
          this.setState({
            errorMessage:
              "Your request generated an error. Try again after sometime",
            loading: false,
          });
        }
        console.log(data);
      })
      .catch((error) => {
        this.setState({
          errorMessage:
            "Your request generated an error. Please check your network connection",
          loading: false,
        });
      });
  }

  render() {
    return this.state.redirect ? (
      <Redirect to={this.state.redirect} />
    ) : this.state.errorMessage ? (
      <CenterBlock height="150">
        <h1 className="text-danger icon-lg">
          <i className="mdi mdi-alert-circle"></i>
        </h1>
        <div className="text-dark text-center" role="alert">
          An error occurred, you can try reloading the page
        </div>
        <button
          type="button"
          onClick={() => this.init()}
          className="btn btn-inverse-primary btn-fw mt-4 mb-5"
        >
          Reload
        </button>
      </CenterBlock>
    ) : (
      <>
        {this.state.loading ? (
          <div className="text-success" style={{ position: "absolute" }}>
            <Spinner size="1.5" />{" "}
          </div>
        ) : null}

        {!this.state.data ? null : <this.RenderTable _data={this.state.data} />}
      </>
    );
  }
}
